<template>
	<BaseLayout :footer-full="true">
		<div class="container">
			<h1 class="heading-1 text-align-center mb-100 mb-200-md">Reward Program Terms and Conditions</h1>
			<section class="grid-md">
				<article class="col-8-md col-offset-2-md position-relative">
					<div class="module">
						<div class="module-header">
							<h2 class="heading-5">Terms and Conditions</h2>
						</div>
						<div class="module-section">
							<p>
								You must agree to the following terms and conditions in order to receive a Share Voucher
								(as defined below) for participating in the Fundrise Reward Share Voucher Program (the
								"Reward Program"), exact details of which were previously provided to you via direct
								communication or in your investor dashboard (the "Offer Details"). These terms and
								conditions are in addition to your existing Fundrise Client Agreement with Fundrise
								Advisors, LLC (“Fundrise Advisors”), and all existing terms of our Privacy Policy and
								our privacy obligations to you shall apply.
							</p>
							<p>
								Through the Reward Program you can take certain actions as specified in the Offer
								Details, and for each "Qualifying Action" (as defined in the Offer Details) Fundrise
								Advisors will grant you a Share Voucher that you may redeem when subscribing for shares
								of either Rise Companies Corp. or a designated Fundrise-sponsored public fund (the
								“Share Voucher”) as described in the Offer Details, as determined by Fundrise Advisors.
								The Share Voucher will be provided to you within approximately one week after all
								conditions of the Qualifying Action are satisfied.
							</p>
							<p>
								Not all Qualifying Actions will be considered valid. We may change the Reward Program in
								the future for existing and/or new clients, and may provide different Offer Details to
								different individuals at the same time. We reserve the right, in our sole discretion, to
								determine that a Share Voucher is not warranted, and/or to change the terms of the
								Reward Program with or without notice to you.
							</p>
							<p>
								This Reward Program is not valid with any other offers and is non-transferrable. Offer
								available to U.S. residents only. As part of the Reward Program, you agree not to
								promote, advertise or otherwise make public your participation in the Reward Program or
								that the Reward Program was made available to you. Fundrise Advisors reserves the right
								to terminate this offer at any time for any reason, to limit the value of the Share
								Vouchers you are eligible to receive, and to refuse or recover any Share Voucher if
								Fundrise Advisors determines that it was obtained under wrongful or fraudulent
								circumstances, that inaccurate or incomplete information was provided in performing the
								Qualifying Action, that any rules or regulations would be violated, that you have
								engaged in any activity that may be deemed a testimonial or an endorsement in connection
								with the Reward Program, or that any terms of the Fundrise Client Agreements have been
								violated.
							</p>
							<p>
								Offer not available for IRA accounts. However, for the avoidance of doubt, this offer is
								available to IRA investors that have investments in a separate non-IRA account on the
								Fundrise Platform.
							</p>
							<p>
								By accepting these terms and conditions and participating in this Reward Program you
								acknowledge certain information so that we can ensure your eligibility. Specifically,
								you represent to us that:
							</p>
							<ol class="ol ml-25">
								<li>
									You aren't otherwise in the investment advisory or brokerage business (or, if you
									are, then your job function is not related to this invitation activity or to the
									financial management of your friend(s)' assets), and you will not provide investment
									advice to any individual in connection with this Reward Program;
								</li>
								<li>
									you aren't a government entity, or an agent of such entity acting on its behalf;
								</li>
								<li>
									you will comply with the requirements for this Reward Program described here, and
									any securities laws that may apply;
								</li>
								<li>
									you are not currently, and have at no time in the past ten (10) years, been the
									subject of: (i) an SEC opinion or order barring, suspending, or prohibiting you from
									acting in any capacity under the federal securities laws; (ii) a conviction by court
									of competent jurisdiction within the United States of any felony or misdemeanor
									involving conduct described in paragraph (2)(A) through (D) of section 203(e) of the
									Investment Advisers Act of 1940 (the “Advisers Act”); (iii) a conviction by a court
									of competent jurisdiction within the United States of engaging in, any of the
									conduct specified in paragraphs (1), (5), or (6) of section 203(e) of the Advisers
									Act; (iv) the entry of any final order by any entity described in paragraph (9)
									section 203(e) of the Advisers Act, or by the U.S. Commodity Futures Trading
									Commission or a self-regulatory organization (as defined in the Form ADV Glossary of
									Terms) of the type described in paragraph (9) of section 203(e) of the Advisers Act;
									(v) the entry of an order, judgment or decree that is described in paragraph (4) of
									section 203(e) of the Advisers Act that is in effect at the time of such
									dissemination by any court of competent jurisdiction within the United States; or
									(vi) an SEC order that you cease and desist from committing or causing a violation
									or future violation of (a) any scienter-based anti-fraud provision of federal
									securities law, including without limitation section 17(a)(1) of the Securities Act
									of 1933 (“Securities Act”), sections 10(b) and 15(c)1 of the Securities Exchange Act
									of 1934, section 206(1) of the Advisers Act, any other rule or regulation thereunder
									or (b) Section 5 of the Securities Act. We may conduct due diligence on you to
									confirm any of the above information; and
								</li>
								<li>you will promptly notify us if any of items 1) through 4) above change.</li>
							</ol>
						</div>
					</div>
				</article>
			</section>
		</div>
	</BaseLayout>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';

function setup(): void {
	useHead({
		title: 'Promotional Program Terms and Conditions',
		meta: [
			{ property: 'og:title', content: 'Promotional Program Terms and Conditions' },
			{
				name: 'description',
				content: 'Promotional Program Terms and Conditions'
			},
			{
				property: 'og:description',
				content: 'Promotional Program Terms and Conditions'
			}
		]
	});
}
setup();
</script>
